import styled from 'styled-components';

export const SMenuContainer = styled.div`
  position: relative;
  flex-shrink: 0;
`;

export const SMenuTrigger = styled.button`
  border: none;
  background: transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;
`;

export const SMenuDropdown = styled.div`
  position: absolute;
  top: 40px;
  right: 0;
  min-width: 200px;
  background: ${({ theme }) => theme.color.white};
  border: 1px solid ${({ theme }) => theme.color.grey85};
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  z-index: 1000;
  padding: 8px 0;
`;

export const SMenuHeader = styled.div`
  padding: 4px 16px 8px;
  color: ${({ theme }) => theme.color.grey50};
  font-size: 13px;
  line-height: 1.2;
`;

export const SMenuItem = styled.button`
  width: 100%;
  border: none;
  background: transparent;
  text-align: left;
  padding: 10px 16px;
  font-size: 15px;
  line-height: 1.2;
  color: ${({ theme }) => theme.color.brand_black};
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.color.grey95};
  }
`;
